import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

import cx from "classnames";

import SVGIcon from "../../../components/SVGIcon"; // eslint-disable-line @typescript-eslint/no-unused-vars

interface IMessageProps {
  id: number;
  title: string;
  text: string;
  type: string;
  linkText?: string;
  linkUrl?: string;
  openInNewTab?: boolean;
  dismissible?: boolean;
  className?: string;
  onDismissClick?: () => void;
}

const Message: FunctionComponent<IMessageProps> = ({
  id,
  title,
  text,
  type,
  linkText,
  linkUrl,
  openInNewTab = false,
  dismissible,
  className,
  onDismissClick,
}) => {
  return (
    <li
      key={id}
      className={cx(className, "media-object media-object--align-top media-object--no-margin")}
    >
      {type.toLowerCase() !== "none" && (
        <div className="media-object__image media-object__image--no-border messages__icon-container">
          <SVGIcon
            name={type.toLowerCase()}
            className="messages__icon icon--align-top icon--md"
          />
        </div>
      )}
      <div className="media-object__text media-object__text--no-border">
        <h4 className="messages__item-heading">{title}</h4>
        <p>
          {text}{" "}
          {linkText && linkUrl && (
            <a
              href={linkUrl}
              target={openInNewTab ? "_blank" : "_self"}
            >
              {linkText}
            </a>
          )}
        </p>
      </div>
      {dismissible && (
        <button
          onClick={onDismissClick}
          className="unbutton messages__item-dismiss"
          title="Dismiss"
        >
          <SVGIcon
            name="close"
            className="messages__icon icon icon--close icon--sm"
          />
        </button>
      )}
    </li>
  );
};

export default Message;
